// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import {useRefreshAllNodes} from '@wandb/weave/react';
import React, {FC} from 'react';
import {toast} from 'react-toastify';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Modal} from 'semantic-ui-react';

import {useUpdateArtifactMutation} from '../../../../../generated/graphql';
import {propagateErrorsContext} from '../../../../../util/errors';
import {ArtifactTTL} from '../../../../ArtifactTTL/utils';
import * as S from '../CreateRegisteredCollectionDrawerInner.styles';

type RemoveArtifactTTLModalProps = {
  open: boolean;
  onClose: () => void;
  artifactName: string;
  versionIndex: number;
  artifactID: string;
};

export const RemoveArtifactTTLModal: FC<RemoveArtifactTTLModalProps> = ({
  open,
  onClose,
  artifactName,
  versionIndex,
  artifactID,
}) => {
  const artifactFullName = artifactName + ':v' + versionIndex;
  const [updateArtifact] = useUpdateArtifactMutation({
    context: propagateErrorsContext(),
  });
  const onUpdateArtifactTTL = (
    artifactIDString: string,
    ttlDurationSeconds: number
  ) => {
    updateArtifact({
      variables: {
        artifactID: artifactIDString,
        ttlDurationSeconds,
      },
    });
  };

  const refreshNodes = useRefreshAllNodes();

  return (
    <Modal open={open} onClose={onClose} style={{width: '600px'}}>
      <Tailwind>
        <div className="w-600px mx-32 mb-32 mt-24">
          <div className="pb-16	font-sans text-xl font-semibold">
            Remove TTL
          </div>
          <div className="pb-24	font-sans text-base text-moon-800">
            Are you sure you want to remove the TTL value on artifact{' '}
            {artifactFullName}? This action will prevent automatic deletion
            based on the current TTL policy.
          </div>
          <S.FooterLeftContent>
            <div className="pr-8">
              <Button
                variant="primary"
                size="large"
                onClick={async () => {
                  // Set artifact TTL to inherit which is default state
                  onUpdateArtifactTTL(artifactID, ArtifactTTL.INHERIT);
                  await refreshNodes();
                  onClose();
                  toast('TTL removed from the artifact ' + artifactFullName);
                }}>
                Remove TTL
              </Button>
            </div>
            <Button variant="ghost" size="large" onClick={onClose}>
              Cancel
            </Button>
          </S.FooterLeftContent>
        </div>
      </Tailwind>
    </Modal>
  );
};
